var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ecircular-description-view" }, [
    _vm.ecircular.type !== _vm.ecircularType.VENDOR
      ? _c("div", { staticClass: "hkland-logo" }, [
          _c("img", {
            directives: [
              {
                name: "region-img-src",
                rawName: "v-region-img-src",
                value: "call-center.png",
                expression: "'call-center.png'",
              },
            ],
            staticStyle: { zoom: "50%" },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "content__description",
      domProps: { innerHTML: _vm._s(_vm.ecircular.description) },
    }),
    _vm._v(" "),
    _c("div", { style: { marginTop: 20 + "px" } }, [
      _c("img", {
        directives: [
          {
            name: "region-img-src",
            rawName: "v-region-img-src",
            value: "email-logo-hkland.png",
            expression: "'email-logo-hkland.png'",
          },
        ],
        staticClass: "hkland-logo__full",
        attrs: { alt: "Hongkong Land" },
      }),
    ]),
    _vm._v(" "),
    _c("div", {
      key: new Date().getTime(),
      domProps: { innerHTML: _vm._s(_vm.ecircular.signature) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }